@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <label class="common-text-input__block-field-input-sequential"
      [ngClass]="{'common-text-input__block-field-input-sequential--error': field.error }"
      [attr.disabled]="field.noEditable?true:null"
      [for]="'field-item-mail-'+field.id">
      <input class="common-text-input__input-sequential"
        type="email"
        [id]="'field-item-mail-'+field.id"
        [name]="'field-item-mail-'+field.id"
        [placeholder]="field.noEditable?'':('front-login.placeholder-mail' | afTranslate)"
        [disabled]="field.noEditable"
        [(ngModel)]="fieldTypeEmail.inputText"
        (blur)="validateEmail()"
        (keyup.enter)="enterValidateEmail()"/>
    </label>
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if (field.errorText) {
          <span>{{field.errorText}}</span>
        }@else if(fieldTypeEmail.inputText){
          <span [afTranslate]="'front-login.error-email-error-format'">El email introducido no es válido</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-input__container-box"
      [ngClass]="{'common-text-input__container-box--error': field.error}"
      [attr.disabled]="field.noEditable?true:null">
      <div class="common-text-input__block-header">
        <label class="common-text-input__label"
          [for]="'field-item-mail-'+field.id">
          <span class="common-text-input__text-label">{{fieldTypeEmail.titleField}}</span>
          @if (field.required) {
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if(field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
            @if (field.relatedInfo?.length) {
              <button class="common-button__icon-sm-noborder"
                pTooltip="{{'common.related-info'| afTranslate}}"
                tooltipPosition="top"
                (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                <i class="lf-icon-search-text common-icon__md"></i>
              </button>
            }
            @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
              <tooltip-in-report [inReport]="fieldTypeEmail.inReport"></tooltip-in-report>
            }
          </div>
        </label>
      </div>
      <div class="common-text-input__block-input"
        [ngClass]="{'common-text-input__block-input--with-value': fieldTypeEmail.inputText && !field.noEditable}">
        <input class="common-text-input__input"
          type="email"
          [id]="'field-item-mail-'+field.id"
          [name]="'field-item-mail-'+field.id"
          [placeholder]="field.noEditable?'':placeholder"
          [disabled]="field.noEditable"
          [(ngModel)]="fieldTypeEmail.inputText"
          (blur)="validateEmail()"
          (keyup.enter)="enterValidateEmail()"/>
        @if (fieldTypeEmail.inputText) {
          <button class="common-text-input__icon-clean-input"
            (click)="resetInput()">
            <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        }
      </div>
    </div>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if (field.errorText) {
          <span>{{field.errorText}}</span>
        }@else if(fieldTypeEmail.inputText){
          <span [afTranslate]="'front-login.error-email-error-format'">El email introducido no es válido</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
</div>
}
